var Midttrafik2016 = Midttrafik2016 || {};

Midttrafik2016.tabs = new function () {
    var self = this;
    this.init = function() {
        this.setupTabs();
    };

    this.setupTabs = function() {
        $('.js-accordion-command').click(function() {
            var activeButtonClass = 'bus-schedule-content-tabs__tab--active';
            var activeTabClass = 'show-tab';
            var isDisabling = $(this).hasClass(activeButtonClass);
            var container = $(this).closest('.js-accordion-parent');
            container.find('.bus-schedule-content-tabs__tab').removeClass(activeButtonClass);
            container.find('.js-accordion-command-content, .bus-schedule-content-tab-content').removeClass(activeTabClass);
            if (!isDisabling) {
                $(this).addClass(activeButtonClass);
                var target = $(this).data('target');
                var targetElement = $('#target-' + target);
                targetElement.addClass(activeTabClass);
                if (Midttrafik2016.webGis)
                    Midttrafik2016.webGis.openContainingWebGisMaps(targetElement);
            }
        });
    };
} ();